import { FormikErrors } from 'formik'

import {
  biggerThanZero,
  onlyNumber,
  required,
} from '../../_utils/formValidators'
import { TypeOfGoodsValues } from './TypeOfGoods.view'

const validateTransportValues = (
  transportingValue: number,
  radioButtonValue: string,
) => {
  if (radioButtonValue === 'true') {
    return (
      required.default(transportingValue.toString()) ||
      onlyNumber.default(transportingValue) ||
      biggerThanZero.default(transportingValue)
    )
  }
  return undefined
}

const validateLiability = (liability: string) => {
  return required.default(liability)
}

const validateRadioButton = (radioButtonValue: string) => {
  return required.default(radioButtonValue)
}

export const validateFieldForm = (formValueFields: TypeOfGoodsValues) => {
  const errors: FormikErrors<TypeOfGoodsValues> = {}

  const {
    transRemoval,
    transTheft,
    liability,
    removalRadioValue,
    theftRadioValue,
  } = formValueFields

  if (validateRadioButton(removalRadioValue)) {
    errors.removalRadioValue = validateRadioButton(removalRadioValue)
  }

  if (validateRadioButton(theftRadioValue)) {
    errors.theftRadioValue = validateRadioButton(theftRadioValue)
  }

  if (validateLiability(liability)) {
    errors.liability = validateLiability(liability)
  }

  if (validateTransportValues(transRemoval, removalRadioValue)) {
    errors.transRemoval = validateTransportValues(
      transRemoval,
      removalRadioValue,
    )
  }

  if (validateTransportValues(transTheft, theftRadioValue)) {
    errors.transTheft = validateTransportValues(transTheft, theftRadioValue)
  }

  return errors
}
